import Link from 'next/link';
import { ConceptId } from '@/lib/contentful/contentTypes';
import { fetchConceptDetails, ResolvedConcept } from 'libs/contentful/rest';
import { conceptUriToHref } from '@/libs/contentful/utils';

async function fetchTaxonomy(entryConceptIds: ConceptId[]): Promise<ResolvedConcept[]> {
  const allConceptIds = entryConceptIds.map(concept => concept.id);
  const concepts = await fetchConceptDetails(allConceptIds);
  return Array.from(concepts.values());
}

interface BlogCategoriesProps {
  concepts: ConceptId[];
}

const tagClassName = 'w-fit font-sans font-semibold text-sm px-4 py-2 border rounded-2xl';

const BlogCategories = async ({ concepts }: BlogCategoriesProps) => {
  const categories = await fetchTaxonomy(concepts);

  return (
    <>
      <div className="flex flex-col md:flex-row gap-6 mt-2">
        <p className="font-sans font-semibold md:mt-[6px]">Tags:</p>
        <div className="flex flex-col sm:flex-row flex-wrap gap-4">
          {categories.map(({ label, uri }, i) => {
            const href = conceptUriToHref(uri);
            return href ? (
              <Link key={i} href={href} className={tagClassName}>
                {label}
              </Link>
            ) : (
              <p key={i} className={tagClassName}>
                {label}
              </p>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default BlogCategories;
